import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTenantSubject } from '@services/registry';

export function useCreateTenantSubject({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload }) => {
            return await createTenantSubject({ tenantId, payload });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['tenantSubjects', tenantId] });
        },
    });
}

